import React from 'react';
import styles from './loading-bar.module.scss';

const LoadingBar = props => {
  return (
    <div className={styles.loadingBar}></div>
  );
};

export default LoadingBar;